var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlantsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3397_10375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8327 23.2501C25.1753 23.2501 25.5038 23.3862 25.746 23.6284C25.9883 23.8706 26.1243 24.1992 26.1243 24.5417C26.1243 24.8843 25.9883 25.2129 25.746 25.4551C25.5038 25.6973 25.1753 25.8334 24.8327 25.8334H13.2077C12.8651 25.8334 12.5366 25.6973 12.2943 25.4551C12.0521 25.2129 11.916 24.8843 11.916 24.5417C11.916 24.1992 12.0521 23.8706 12.2943 23.6284C12.5366 23.3862 12.8651 23.2501 13.2077 23.2501H24.8327ZM24.8327 14.2084C25.1619 14.2088 25.4786 14.3348 25.7179 14.5608C25.9573 14.7868 26.1014 15.0957 26.1207 15.4244C26.14 15.753 26.0331 16.0767 25.8218 16.3291C25.6105 16.5816 25.3107 16.7438 24.9838 16.7827L24.8327 16.7917H13.2077C12.8786 16.7911 12.5621 16.6648 12.323 16.4387C12.0838 16.2126 11.94 15.9037 11.9209 15.5751C11.9018 15.2466 12.0088 14.9231 12.2201 14.6708C12.4314 14.4185 12.731 14.2563 13.0578 14.2175L13.2077 14.2084H24.8327ZM24.8327 5.16675C25.1619 5.16711 25.4786 5.29317 25.7179 5.51918C25.9573 5.74518 26.1014 6.05406 26.1207 6.38272C26.14 6.71137 26.0331 7.03499 25.8218 7.28745C25.6105 7.53991 25.3107 7.70216 24.9838 7.74104L24.8327 7.75008H13.2077C12.8786 7.74939 12.5621 7.6231 12.323 7.397C12.0838 7.17089 11.94 6.86203 11.9209 6.53347C11.9018 6.20492 12.0088 5.88145 12.2201 5.62913C12.4314 5.37681 12.731 5.21466 13.0578 5.17579L13.2077 5.16675H24.8327Z",
    fill: "#815AD3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6.5,
    r: 1.5,
    fill: "#815AD3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 15.5,
    r: 1.5,
    fill: "#815AD3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 24.5,
    r: 1.5,
    fill: "#815AD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3397_10375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantsList);
export default __webpack_public_path__ + "static/media/plantsList.ff7196ca6028fe668e9873c43866ed61.svg";
export { ForwardRef as ReactComponent };